import React, { Component} from 'react';
import {CardSmall} from '../../widgets/Cards';

export default class Appointment extends Component {


    
    render() {
        return (
            <CardSmall title='Appointments'>
                Appointments
            </CardSmall>
        )
    }
    
}
